import { useCatalogStore } from '~/layers/catalog/store/catalog'

export const useCatalogSort = () => {
  const store = useCatalogStore()
  const bus = useCatalogEventBus()
  return {
    set(code: string, direction: 'asc' | 'desc') {
      store.setSort(code, direction)
      bus.emit('sort:updated')
    },
  }
}
